module.exports = __webpack_public_path__ + "static/media/QuickShopImage.2648011c.png";